import * as types from "../types";

export default {            
};

// export default mutations;
